export default __webpack_public_path__ + "static/media/angular-logo.b2ed7398.png";